import { Typography, Row, Col, InputNumber } from 'antd';

import OpenUpdateMinimumRequirementButton from 'common/components/preview-requirements/OpenUpdateMinimumRequirementButton';

import { RequiredPropertyItem } from './RequiredPropertyElement';

import { useRequiredActiveProductContext } from './hooks';

import { useGetProductFullView } from 'hooks';
import { additionalRequirementFieldsLowercase } from './constants';

export const AdditionalRequiredActiveProduct = ({
  requiredErrorFields = [],
  entityId,
  onRevalidateProduct,
  productForm,
  additionalRequirements,
}) => {
  const allAdditionalFields = Object.keys(additionalRequirementFieldsLowercase);

  return (
    <>
      {allAdditionalFields.map((field) => {
        const isError = requiredErrorFields.includes(field);

        const { fieldDisplayName, fieldName, isBoolean } =
          additionalRequirementFieldsLowercase[field];

        return isError ? (
          <RequiredPropertyItem key={fieldName}>
            <AdditionalRequiredPropertyName
              propertyName={fieldDisplayName}
              isError={true}
            >
              {isBoolean ? null : (
                <RequiredPropertyTotalAsset
                  value={additionalRequirements?.[fieldName]}
                  isError={true}
                />
              )}
            </AdditionalRequiredPropertyName>

            <AdditionalRequiredPropertyInput
              entityId={entityId}
              fieldName={fieldName}
              onRevalidateProduct={onRevalidateProduct}
              productForm={productForm}
            />
          </RequiredPropertyItem>
        ) : null;
      })}
    </>
  );
};

export const AdditionalRequiredPropertyInput = ({
  entityId,
  fieldName,
  style = {},
  onRevalidateProduct,
  productForm,
}) => {
  const { productFull } = useGetProductFullView({
    productId: entityId,
  });

  const { requiredForm } = useRequiredActiveProductContext();

  return (
    <Col flex={1} style={style}>
      <OpenUpdateMinimumRequirementButton
        productDetail={productFull}
        entityData={{
          ...productFull,
          id: entityId,
        }}
        item={{
          id: fieldName,
        }}
        onInvalidateProductValidation={() =>
          onRevalidateProduct({
            isAdditional: true,
          })
        } // with additional we don't need validate the current form value
        requiredForm={productForm || requiredForm}
      />
    </Col>
  );
};

export const AdditionalRequiredPropertyName = ({
  propertyName,
  children,
  isError,
  ...otherProps
}) => {
  return (
    <Col span={16} {...otherProps}>
      <Row justify='space-between' align='middle'>
        <Col>
          <Typography.Text strong type={isError ? 'danger' : undefined}>
            {propertyName}
          </Typography.Text>
        </Col>
        <Col flex='120px'>{children}</Col>
      </Row>
    </Col>
  );
};

export const RequiredPropertyTotalAsset = ({ value, isError }) => {
  return (
    <InputNumber
      readOnly
      value={value}
      status={isError ? 'error' : undefined}
    />
  );
};
